import * as _fastDeepEqual2 from "fast-deep-equal";
var _fastDeepEqual = _fastDeepEqual2;
try {
  if ("default" in _fastDeepEqual2) _fastDeepEqual = _fastDeepEqual2.default;
} catch (e) {}
var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});
// https://github.com/ajv-validator/ajv/issues/889
const equal = _fastDeepEqual;
equal.code = "require(\"ajv/dist/runtime/equal\").default";
exports.default = equal;
//# sourceMappingURL=equal.js.map
export default exports;
export const __esModule = exports.__esModule;